// src/reducers/userReducer.js
import {
    GET_MEALDEAL_SUCCESS,
    GET_MEALDEAL_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const mealDealReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_MEALDEAL_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_MEALDEAL_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  